var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfGridLines = function SvgPdfGridLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 19.5v-4h-4V14h4v-4h-4V8.5h4v-4H10v4h4v-4h1.5v4h4V10h-4v4h4v1.5h-4v4H14v-4h-4v4zM10 14h4v-4h-4z"
  })));
};
export default SvgPdfGridLines;